// Data Dashboard Page Translation
export default {
  // Buttons
  buttons: {
    viewDetails: "Dashboard Details",
  },

  // Tabs
  tabs: {
    balanceBoard: "Balance Dashboard",
    transactionBoard: "Transaction Dashboard",
  },

  // Messages
  messages: {
    noData: "No data available",
  },
};
